module.exports = __webpack_public_path__ + "img/test-icon-overview.a811cb0a.png";